import { useEffect, useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Composer } from "@/components/shared/Composer";
import { useAuth } from "@/context/AuthContext";
import { roleFromPath, DEFAULT_ROUTE } from "@/config/nav";
import { Menu, Ship } from "lucide-react";

export function Layout() {
  const { pathname } = useLocation();
  const { auth } = useAuth();
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);

  useEffect(() => {
    setMobileNavigationOpen(false);
  }, [pathname]);

  // Non-admins are confined to their own workspace.
  if (auth && !auth.isAdmin) {
    const pathRole = roleFromPath(pathname);
    if (pathRole !== auth.realRole) {
      return <Navigate to={DEFAULT_ROUTE[auth.realRole] || "/sales/inbox"} replace />;
    }
  }

  return (
    <div className="enterprise-shell flex min-h-[100dvh] bg-[#f3f6fa]">
      <Sidebar mobileOpen={mobileNavigationOpen} onMobileOpenChange={setMobileNavigationOpen} />
      <main className="flex h-[100dvh] min-w-0 flex-1 flex-col overflow-hidden bg-[#f3f6fa] lg:h-screen">
        <header className="flex h-14 shrink-0 items-center gap-3 border-b border-slate-200 bg-white px-3 lg:hidden">
          <button
            type="button"
            onClick={() => setMobileNavigationOpen(true)}
            aria-label="Open workspace navigation"
            aria-haspopup="dialog"
            aria-expanded={mobileNavigationOpen}
            aria-controls="mobile-workspace-navigation"
            className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-200 text-slate-700 transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
          >
            <Menu className="h-5 w-5" />
          </button>
          <div className="flex min-w-0 items-center gap-2.5">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-[#10233f]"><Ship className="h-4 w-4 text-white" /></div>
            <div className="min-w-0">
              <div className="truncate text-sm font-bold text-slate-900">JVK FreightOps</div>
              <div className="truncate text-[10px] font-semibold uppercase tracking-wider text-slate-500">Workspace</div>
            </div>
          </div>
        </header>
        <Outlet />
      </main>
      <Composer />
    </div>
  );
}
